document.addEventListener('DOMContentLoaded', () => {
  // CSS inject karke dialog ko instantly hide karo
  const style = document.createElement('style');
  style.textContent = `
    #search-modal,
    dialog-component[id*="search"] {
      display: none !important;
      visibility: hidden !important;
    }
  `;
  document.head.appendChild(style);

  // Search button click pe redirect
  document.addEventListener('click', (e) => {
    const target = e.target.closest('button, a');
    if (!target) return;
    
    const onAttr = target.getAttribute('on:click') || '';
    const ariaControls = target.getAttribute('aria-controls') || '';
    
    if (onAttr.includes('search') || ariaControls.includes('search') || target.closest('.search-action')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      window.location.href = '/search';
    }
  }, true);
});